import axios from 'axios'
import { UrlBase } from './config'

const businesses = {}

businesses.addContact = async (token, companyId, appId, data) => {
  const { businessId, ...all } = data
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        contacts: [{ ...all }]
      },
      method: 'PUT',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.deleteContact = async (token, companyId, appId, data) => {
  try {
    const { businessId, contact } = data
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        contacts: [contact]
      },
      method: 'DELETE',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}/contacts`
    }

    await axios(request)
    return true
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.getBusiness = async (token, companyId, appId, businessId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'GET',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.getBusinesses = async (token, companyId, appId, pagination, search, advancedSearch, location) => {
  try {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      },
      params: {
        page: pagination.page,
        sortBy: pagination.sortBy,
        descending: pagination.descending,
        limit: pagination.itemsPerPage,
        search: search,
        location,
        categories: advancedSearch.categories,
        others: advancedSearch.otherLabels,
        segment: advancedSearch.segments
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/businesses'
    }
    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.getContacts = async (token, companyId, appId, businessId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      method: 'GET',
      params: {
        getUsers: true
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}`
    }
    const response = await axios(request)
    return response.data.business
  } catch (e) {
    throw new Error(e.message)
  }
}

businesses.newBusiness = async (token, companyId, appId, data) => {
  const { code, name, email, categories, phone, address, url, location, image, contacts, segment, others } = data
  try {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: UrlBase + 'companies/' + companyId + '/apps/' + appId + '/businesses',
      data: { code, name, email, categories, phone, address, businessUrl: url, location, image, contacts, segment, others }
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.updateBusiness = async (token, companyId, appId, data) => {
  try {
    const { code, businessId, name, email, categories, phone, address, url, location, image, contacts, segment, others } = data

    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: { code, name, email, categories, phone, address, businessUrl: url, location, image, contacts, segment, others },
      method: 'PUT',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}`
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.deleteBusiness = async (token, companyId, appId, businessId) => {
  try {
    const request = {
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: { businessId },
      method: 'DELETE',
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/${businessId}`
    }
    await axios(request)
    return true
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else throw new Error(message.data.error)
  }
}

businesses.uploadFile = async (token, companyId, appId, { file, headers }) => {
  try {
    const fd = new FormData()
    /* eslint-enable */
    fd.append('upload-files', file)
    fd.append('fileHeaders', JSON.stringify(headers))

    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + token
      },
      url: `${UrlBase}companies/${companyId}/apps/${appId}/businesses/file/upload`,
      data: fd
    }

    const response = await axios(request)
    return response.data
  } catch (error) {
    const message = error.response
    if (!message) throw new Error(error.message)
    else if (message.data.errors && message) {
      let errorString = message.data.error
      message.data.errors.forEach(function (errorItem) {
        errorString += errorItem.location
      })
      throw new Error(errorString)
    } else throw new Error(message.data.error)
  }
}

export default businesses
